import { FC, useEffect, useState } from 'react';
import { NewRelicWrapper, ButtonWrapper } from './NewRelicConsent.styles';
import { TextBlock } from '@/components/text/TextBlock';
import { TypeOfText } from '@/components/text/TextBlock';
import { Button } from '@components/Button/DefaultButton/Button';
import { useAppSelector } from '@/app/hooks';
import { pages } from '@/defaultVerbiages';
import { initializeNewRelic, updateNewRelicUser, logConsent } from '@/config/newrelic';

type NewRelicConsentProps = {
  onConsent: (value: boolean) => void;
  userEmail?: string;
};

export const NewRelicConsent: FC<NewRelicConsentProps> = ({ onConsent, userEmail }) => {
  const TemplateConfig = useAppSelector((state: any) => state.TemplateConfig);
  const [isInitialized, setIsInitialized] = useState(false);

  const isHidden = TemplateConfig?.pages?.features?.newRelic?.isHidden ?? TemplateConfig?.pages?.features?.fullStory?.isHidden ?? pages.features.fullStory.isHidden ?? false;
  const title = TemplateConfig?.pages?.features?.fullStory?.title ?? TemplateConfig?.pages?.features?.newRelic?.title ?? pages.features.fullStory.title;
  const body = TemplateConfig?.pages?.features?.fullStory?.body ?? TemplateConfig?.pages?.features?.newRelic?.body ?? pages.features.fullStory.body;
  const declineLabel =
    TemplateConfig?.pages?.features?.fullStory?.buttonDecline ?? TemplateConfig?.pages?.features?.newRelic?.buttonDecline ?? pages.features.fullStory.buttonDecline;
  const acceptLabel = TemplateConfig?.pages?.features?.fullStory?.buttonAccept ?? TemplateConfig?.pages?.features?.newRelic?.buttonAccept ?? pages.features.fullStory.buttonAccept;
  const silentTracking = TemplateConfig?.pages?.features?.fullStory?.silentTracking ?? TemplateConfig?.pages?.features?.newRelic?.silentTracking ?? false;

  useEffect(() => {
    const isEmailValid = userEmail ? /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(userEmail) : false;
    if (userEmail && isEmailValid) {
      updateNewRelicUser(userEmail);
    }
  }, [userEmail]);

  useEffect(() => {
    // initialize when silent tracking
    if (silentTracking && !isInitialized) {
      initializeNewRelic(TemplateConfig, userEmail);
      setIsInitialized(true);
    }
  }, [silentTracking, userEmail, isInitialized, TemplateConfig]);

  const updateConsentValue = (value: boolean) => {
    onConsent(value);
    if (value) {
      initializeNewRelic(TemplateConfig, userEmail);
      if (userEmail) {
        updateNewRelicUser(userEmail);
      }
      logConsent(value, userEmail);
    }
  };

  if (isHidden) {
    return null;
  }

  return (
    <NewRelicWrapper>
      <TextBlock text={title} direction="center" type={TypeOfText.H2} />
      <TextBlock text={body} type={TypeOfText.Subtitle} />
      <ButtonWrapper>
        <Button label={declineLabel} onClick={() => updateConsentValue(false)} variant="secondary" buttonSize="l" />
        <Button label={acceptLabel} onClick={() => updateConsentValue(true)} variant="primary" buttonSize="l" />
      </ButtonWrapper>
    </NewRelicWrapper>
  );
};

export default NewRelicConsent;
